import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, size = 20, readOnly = false, testid }) => (
  <div className="inline-flex items-center gap-0.5" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= Math.round(value);
      return (
        <button key={n} type="button" disabled={readOnly}
          onClick={() => !readOnly && onChange && onChange(n)}
          className={`${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform`}
          aria-label={`${n} estrela${n > 1 ? "s" : ""}`}>
          <Star
            style={{ width: size, height: size }}
            className={filled ? "text-amber-400 fill-amber-400" : "text-slate-300"}
            strokeWidth={1.5}
          />
        </button>
      );
    })}
  </div>
);
